import React, { ReactNode } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
// import CssBaseline from '@mui/material/CssBaseline';

import lightTheme from './lightTheme';

export interface ThemeProviderProps {
  children: ReactNode;
}

const AppThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const theme = createTheme(lightTheme);

  return (
    <ThemeProvider theme={theme}>
      {/* <CssBaseline /> */}
      {children}
    </ThemeProvider>
  );
};

export default AppThemeProvider;
